import { axios } from "../../../lib/axios";

export const loginUser = async ({ username, password }: any) => {
  const response = await axios.post(`/login`, { username, password });

  return response.data;
};
